export default __webpack_public_path__ + "static/media/metamask-fox.45038d58.svg";